/**
 * MessageComposer — Lexical-based composer (formerly MessageComposerV2).
 *
 * KAP-300 finisher: V2 graduated from preview-flag to the production composer
 * for everyone. The legacy V1 textarea + `kapsa.composerV2` localStorage gate
 * have been removed. Existing imports of this module continue to resolve to
 * the same component via this re-export.
 */
import MessageComposerV2 from './MessageComposerV2';

export default MessageComposerV2;
